export default function initPaymentState() {
  const allowed     = ['cash', 'lease', 'finance'];
  const body        = document.body;
  const paymentLink = document.querySelector('[data-payment-link]');
  const input       = document.querySelector('[data-hero-payment-input]');
  let current = '';

  const getCookiePayment = () => {
    const match = document.cookie.match(/(?:^|; )autonia_payment=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  // Cookie banner is blocking, but doesn't block script execution — don't write
  // the cookie until the visitor has actually clicked through it (either button
  // counts, "technisch notwendig" is included in both).
  const hasCookieConsent = () => !!localStorage.getItem('autonia_cookie_consent');
  const writeCookie = (value) => {
    document.cookie = `autonia_payment=${value};path=/;max-age=${60 * 60 * 24 * 30}`;
  };

  const updateLink = (value) => {
    if (!paymentLink) return;
    try {
      const url = new URL(paymentLink.getAttribute('href'), window.location.origin);
      url.searchParams.set('payment', value);
      paymentLink.setAttribute('href', url.toString());
    } catch (_) {}
  };

  const updateButtons = (value) => {
    document.querySelectorAll('[data-payment-option], [data-hero-payment]').forEach((btn) => {
      const option = btn.getAttribute('data-payment-option') || btn.getAttribute('data-hero-payment');
      const isActive = option === value;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const setPayment = (value, opts = {}) => {
    const next = allowed.includes(value) ? value : 'lease';
    if (next === current) return;
    current = next;
    if (input) input.value = next;
    body.classList.remove('payment-cash', 'payment-lease', 'payment-finance');
    body.classList.add(`payment-${next}`);
    if (opts.cookie !== false && hasCookieConsent()) {
      writeCookie(next);
    }
    updateButtons(next);
    updateLink(next);
    window.dispatchEvent(new CustomEvent('autonia:paymentChange',      { detail: { value: next } }));
    window.dispatchEvent(new CustomEvent('autonia:purchaseTypeChange', { detail: { type: next } }));
  };

  const initial = input?.value
    || body.className.match(/payment-(cash|lease|finance)/)?.[1]
    || getCookiePayment()
    || 'lease';

  // payment-forced: this vehicle does not offer the visitor's choice, so the
  // page shows its first available type instead (TD-119). That is a fallback
  // for this page only and must not overwrite the visitor's global choice.
  setPayment(initial, { cookie: !body.classList.contains('payment-forced') });

  // Consent arrived after we already resolved the current payment state above
  // (banner click, or a stored decision from a previous page load racing with
  // this script) — write the cookie retroactively for whatever is active now.
  let chosenHere = false;
  window.addEventListener('autonia:cookieConsent', () => {
    if (chosenHere || !body.classList.contains('payment-forced')) writeCookie(current);
  });

  document.querySelectorAll('[data-payment-toggle], [data-hero-payment-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-payment-option], [data-hero-payment]');
      if (!btn) return;
      const value = btn.getAttribute('data-payment-option') || btn.getAttribute('data-hero-payment');
      if (value) { chosenHere = true; setPayment(value); }
    });
  });

  // Payment panel collapse/expand (persisted in localStorage)
  const toggle     = document.querySelector('[data-payment-toggle]');
  const collapseBtn = toggle?.querySelector('[data-payment-toggle-collapse]');
  if (toggle && collapseBtn) {
    const storageKey    = 'autonia_settings';
    const readSettings  = () => { try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (_) { return {}; } };
    const writeSettings = (s) => { try { localStorage.setItem(storageKey, JSON.stringify(s)); } catch (_) {} };
    const applyState    = (collapsed) => {
      toggle.classList.toggle('is-collapsed', collapsed);
      collapseBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      const icon = collapseBtn.querySelector('.material-symbols-outlined');
      if (icon) icon.textContent = collapsed ? 'payments' : 'close';
    };

    applyState(!!readSettings().paymentToggleCollapsed);

    collapseBtn.addEventListener('click', () => {
      const next = !toggle.classList.contains('is-collapsed');
      applyState(next);
      const settings = readSettings();
      settings.paymentToggleCollapsed = next;
      writeSettings(settings);
    });
  }
}
